import React from 'react';
import { storyblokEditable } from "@storyblok/react";

function Headinfo({ blok }) {
  return (
    <div className='headinfo-wrap wrap' {...storyblokEditable(blok)}>
        <h1 className='text-3xl pb-1.5 merriweather'>{blok.headline}</h1>
        <p>{blok.infotext}</p>
    </div>
  )
}

export default Headinfo